import React from 'react';
import ReactDOM from 'react-dom';
//import OrderWizardContainer from './orderingwizard/OrderWizardContainer';
//import RegistrationWizardContainer from "./registrationwizard/RegistrationWizardContainer";
import connect from "react-redux/es/connect/connect";
import CompanyPage from "./view/CompanyPage";
import NavbarContainer from "../main/NavbarContainer";

const MAIN_SCREEN = 1;
//const REGISTRATION_WIZARD = 2;
//const ORDERING_WIZARD = 3;

class CompanyPageContainer extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            step : MAIN_SCREEN,
        };

        this.webFormRef = React.createRef();

        console.log("main page state");

        this.steps = {

            [MAIN_SCREEN] : () => {
                console.log("main screen");
                return (<CompanyPage onOrder={this.handleOrder} webFormRef={this.webFormRef}/>);
            },

            /*
            [REGISTRATION_WIZARD] : () => {
                return (
                    <RegistrationWizardContainer
                        state={this.state}
                        onOrder={this.handleOrder}/>
                );
            },

            [ORDERING_WIZARD] : () => {
                return (
                    <OrderWizardContainer
                        state={this.state}/>
                );
            },
            */
        };
    }

    render() {
        return (
            <React.Fragment>
                <NavbarContainer onOrder = {this.handleWebForm}/>
                {this.steps[this.state.step]()}<br/>
            </React.Fragment>
        );
    }

    handleOrder = () => {
        this.handleWebForm();
        //this.setState({step: (this.props.authenticated ? ORDERING_WIZARD : REGISTRATION_WIZARD )});
    };

    handleWebForm = () => {
        const myDomNode = ReactDOM.findDOMNode(this.webFormRef.current);
        myDomNode.scrollIntoView()
    }



}

function mapStateToProps(state) {
    return {
        authenticated : state.authentication.authenticated,
        username : state.authentication.username
    };
}


export default connect(mapStateToProps)(CompanyPageContainer);


// WEBPACK FOOTER //
// ./src/components/company/CompanyPageContainer.jsx